import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useCookies } from 'react-cookie';
import { EMPTY_ARRAY } from '../../../../../core/util/array';

const PROFILE_BADGE_VIEWED_COOKIE = 'pbvc';

const getViewedCookies = (cookies: any) => {
  const viewedCookies = cookies[PROFILE_BADGE_VIEWED_COOKIE];
  if (!viewedCookies) return [];

  return viewedCookies.split(',');
};

export const useProfileBadge = () => {
  const [badgeList, setBadgeList] = useState([]);
  const [cookies, setCookie] = useCookies([PROFILE_BADGE_VIEWED_COOKIE]);

  const userProfiles = useSelector(
    (state: any) => (state.account.summary && state.account.summary.user_profiles) || EMPTY_ARRAY
  );
  const activeProfileId = useSelector(
    (state: any) => state.newBooking.profile && state.newBooking.profile.userProfileId
  );

  const mostRecentAccountBookingsProfileIds = useMemo(() => {
    const bookings = [];
    for (let profileIdx = 0; profileIdx < userProfiles.length; ++profileIdx)
      if (
        userProfiles[profileIdx] &&
        userProfiles[profileIdx].is_verified &&
        !userProfiles[profileIdx].is_hidden &&
        userProfiles[profileIdx].bookings.most_recent
      )
        bookings.push(userProfiles[profileIdx].bookings.most_recent.user_profile_id);

    return bookings;
  }, [userProfiles]);

  useEffect(() => {
    const viewedCookies = getViewedCookies(cookies);

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
    if (!viewedCookies.includes(activeProfileId) && badgeList.includes(activeProfileId)) {
      setCookie(PROFILE_BADGE_VIEWED_COOKIE, [...viewedCookies, activeProfileId].join(','), {
        path: '/',
        expires: new Date(2099, 0, 0),
      });
    }
  }, [activeProfileId, cookies, setCookie, badgeList]);

  useEffect(() => {
    const viewedCookies = getViewedCookies(cookies);

    const tempBadgeList = [];
    for (let idIdx = 0; idIdx < mostRecentAccountBookingsProfileIds.length; ++idIdx) {
      const profileId = mostRecentAccountBookingsProfileIds[idIdx];

      if (!viewedCookies.includes(profileId)) {
        tempBadgeList.push(profileId);
      }
    }

    // @ts-expect-error ts-migrate(2345) FIXME: Type 'any' is not assignable to type 'never'.
    setBadgeList(tempBadgeList);
  }, [mostRecentAccountBookingsProfileIds, cookies]);

  return badgeList;
};
